export function confirmCancel() {
  const form = document.getElementById("rezerwacja-anuluj-form");

  if (form) {
    const checkbox = form.querySelector('input[name="zgoda_na_anulowanie"]');
    const submitButton = form.querySelector('button[type="submit"]');

    submitButton.disabled = !checkbox.checked;

    checkbox.addEventListener("change", function () {
      submitButton.disabled = !checkbox.checked;
    });
  }
}
